// Todo: This component is using the code provided by the React library. Refactoring will be needed later.

import React, { useState, useEffect, useMemo } from "react";
import DebouncedInput from './debouncedInput';

interface IFilterProps {
    column: any;
    flatRows: any;
}

const Filter = React.memo((props: IFilterProps) => {
    const { column, flatRows } = props;

    const firstValue = useMemo(
        (): string | number => flatRows[0]?.getValue(column.id),
        [flatRows, column.id]
    );

    const columnFilterValue = column.getFilterValue() ?? "";

    const [localFilter, setLocalFilter] = useState<string | number>(columnFilterValue);

    useEffect(() => {
        setLocalFilter(columnFilterValue);
    }, [columnFilterValue]);


const sortedUniqueValues = useMemo(() => {
    if (column.columnDef?.meta?.options) {
        return [...column.columnDef.meta.options].sort((a, b) =>
            String(a).localeCompare(String(b))
        );
    }
    return typeof firstValue === "number"
        ? []
        : Array.from(column.getFacetedUniqueValues().keys()).sort();
}, [column, firstValue]);

    const clearFilter = () => {
        setLocalFilter("");
        column.setFilterValue("");
    };

    if (typeof firstValue === "number") {
        const [min, max] = column.getFacetedMinMaxValues() ?? [undefined, undefined];
        const [from, to] = (columnFilterValue as [number, number]) || [];

        return (
            <div className="flex flex-col">
                <div className="flex space-x-2">
                    <DebouncedInput
                        type="number"
                        min={min}
                        max={max}
                        value={from ?? ""}
                        onChange={(val) => column.setFilterValue([val, to])}
                        placeholder={`Min ${min ?? ""}`}
                        className="filter-input"
                    />
                    <DebouncedInput
                        type="number"
                        min={min}
                        max={max}
                        value={to ?? ""}
                        onChange={(val) => column.setFilterValue([from, val])}
                        placeholder={`Max ${max ?? ""}`}
                        className="filter-input"
                    />
                </div>
                <div className="h-1" />
            </div>
        );
    }

    return (
        <div className="filterdropdownDatalist" style={{ position: "relative" }}>
            <datalist id={column.id + "list"}>
                {sortedUniqueValues.slice(0, 5000).map((val: any) => (
                    <option value={val} key={val} />
                ))}
            </datalist>
            <DebouncedInput
                type="text"
                value={localFilter}
                onChange={(val) => {
                    setLocalFilter(val);
                    column.setFilterValue(val);
                }}
                placeholder={`Select ${column.id
                                .split(/(?=[A-Z])/)[0]
                                .replace(/^./, (char) => char.toUpperCase())}`}
                className="filter-input"
                list={column.id + "list"}
            />
            {localFilter !== "" && (
                <button
                    type="button"
                    onClick={clearFilter}
                    className="clear-filter-button"
                    aria-label="Clear filter"
                >
                    ×
                </button>
            )}
            <div className="h-1" />
        </div>
    );
},
    (prev, next) =>
        prev.column === next.column && prev.flatRows === next.flatRows
);

export default Filter;